/* Viora: quick add, Accessories menu, announcement bar, Shop the setup,
   See it in hand videos and back-in-stock alerts. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- add to cart (quick add, setup, video tags) ---------- */
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }
  function busy(btn, on) { btn.disabled = on; btn.classList.toggle('is-busy', on); }
  function done(btn) {
    var keep = btn.innerHTML;
    btn.classList.add('is-done');
    btn.innerHTML = btn.classList.contains('qa-btn') ? '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg><span>Added</span>' : 'Added ✓';
    setTimeout(function () { btn.innerHTML = keep; btn.classList.remove('is-done'); }, 1600);
  }
  function openCart() { if (window.VioraCart && window.VioraCart.open) window.VioraCart.open(); }
  function closePops(except) {
    document.querySelectorAll('.qa-pop:not([hidden])').forEach(function (p) {
      if (p === except) return;
      p.hidden = true;
      var b = p.parentNode.querySelector('[data-qa-open]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qa-open]');
    if (open) {
      e.preventDefault();
      var pop = open.parentNode.querySelector('.qa-pop');
      var show = pop.hidden;
      closePops(pop);
      pop.hidden = !show;
      open.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) { var first = pop.querySelector('button:not([disabled])'); if (first) first.focus({ preventScroll: true }); }
      return;
    }
    var one = e.target.closest('[data-qa]');
    if (one && !one.disabled) {
      e.preventDefault();
      var pop2 = one.closest('.qa-pop');
      var shown = pop2 ? pop2.parentNode.querySelector('[data-qa-open]') : one;
      busy(one, true);
      addItems([{ id: parseInt(one.getAttribute('data-qa'), 10), quantity: 1 }])
        .then(function () { busy(one, false); if (pop2) { pop2.hidden = true; shown.setAttribute('aria-expanded', 'false'); } done(shown); openCart(); })
        .catch(function () { busy(one, false); });
      return;
    }
    var many = e.target.closest('[data-qa-many]');
    if (many && !many.disabled) {
      e.preventDefault();
      var list = many.getAttribute('data-qa-many').split(',').filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      busy(many, true);
      addItems(list).then(function () { busy(many, false); done(many); openCart(); }).catch(function () { busy(many, false); });
      return;
    }
    if (!e.target.closest('.qa-pop')) closePops(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePops(null); });

  /* ---------- announcement bar: one message at a time ---------- */
  var annc = document.querySelector('[data-annc]');
  if (annc) {
    var msgs = annc.querySelectorAll('.annc-m'), cur = 0, timer = null;
    function show(i) {
      if (!msgs.length) return;
      cur = (i + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) { m.classList.toggle('is-on', k === cur); });
    }
    function start() { if (reduced || msgs.length < 2 || timer) return; timer = setInterval(function () { if (!document.hidden) show(cur + 1); }, 5000); }
    function stop() { clearInterval(timer); timer = null; }
    show(0);
    annc.querySelectorAll('[data-annc-step]').forEach(function (b) {
      b.hidden = msgs.length < 2;
      b.addEventListener('click', function () { stop(); show(cur + parseInt(b.getAttribute('data-annc-step'), 10)); start(); });
    });
    annc.addEventListener('mouseenter', stop);
    annc.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- Accessories dropdown (computers) ---------- */
  var mm = document.querySelector('[data-mm]');
  var trig = document.querySelector('[data-mm-trigger]');
  if (mm && trig) {
    var hideT = null, canHover = window.matchMedia('(hover: hover) and (min-width: 900px)');
    function mmOpen() {
      if (!canHover.matches) return;
      clearTimeout(hideT);
      mm.hidden = false;
      requestAnimationFrame(function () { mm.classList.add('is-open'); });
      trig.setAttribute('aria-expanded', 'true');
      trig.classList.add('mm-on');
      document.body.classList.add('mm-open');
    }
    function mmClose(now) {
      clearTimeout(hideT);
      hideT = setTimeout(function () {
        mm.classList.remove('is-open');
        trig.setAttribute('aria-expanded', 'false');
        trig.classList.remove('mm-on');
        document.body.classList.remove('mm-open');
        setTimeout(function () { if (!mm.classList.contains('is-open')) mm.hidden = true; }, 180);
      }, now ? 0 : 140);
    }
    trig.addEventListener('mouseenter', mmOpen);
    trig.addEventListener('focus', mmOpen);
    trig.addEventListener('mouseleave', function () { mmClose(false); });
    mm.addEventListener('mouseenter', function () { clearTimeout(hideT); });
    mm.addEventListener('mouseleave', function () { mmClose(false); });
    mm.addEventListener('focusout', function (e) { if (!mm.contains(e.relatedTarget) && e.relatedTarget !== trig) mmClose(true); });
    trig.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mmOpen(); var f = mm.querySelector('a'); if (f) f.focus(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mm.hidden) { mmClose(true); trig.focus(); } });
    window.addEventListener('scroll', function () { if (!mm.hidden && window.scrollY > 600) mmClose(true); }, { passive: true });
  }

  /* ---------- phone menu: Accessories opens into tiles ---------- */
  document.querySelectorAll('[data-mgrp-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sub = b.nextElementSibling, open = sub.hidden;
      sub.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.parentNode.classList.toggle('is-open', open);
    });
  });

  /* ---------- Shop the setup: dots <-> list ---------- */
  document.querySelectorAll('[data-su]').forEach(function (su) {
    function pick(n) {
      su.querySelectorAll('[data-su-dot]').forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-su-dot') === n); });
      su.querySelectorAll('[data-su-item]').forEach(function (it) { it.classList.toggle('is-on', it.getAttribute('data-su-item') === n); });
    }
    su.querySelectorAll('[data-su-dot]').forEach(function (d) {
      d.addEventListener('click', function () {
        var n = d.getAttribute('data-su-dot'); pick(n);
        var it = su.querySelector('[data-su-item="' + n + '"]');
        if (it && window.matchMedia('(max-width: 899px)').matches) it.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      });
    });
    su.querySelectorAll('[data-su-item]').forEach(function (it) {
      it.addEventListener('mouseenter', function () { pick(it.getAttribute('data-su-item')); });
    });
  });

  /* ---------- See it in hand: swipe row of videos ----------
     Videos play on mute while they're on screen and pause when they scroll away
     (only the ones people can see ever load). Tap a video for sound; one at a time.
     Phones in Low Power Mode block autoplay, and shoppers who prefer less motion
     get no autoplay: both see a play button instead. */
  document.querySelectorAll('[data-vr-rail]').forEach(function (rail) {
    var row = rail.querySelector('[data-vr-row]');
    if (!row) return;
    var prev = rail.querySelector('[data-vr-prev]'), next = rail.querySelector('[data-vr-next]');
    var sib = rail.nextElementSibling;
    var dots = sib && sib.hasAttribute('data-vr-dots') ? sib : null;
    var tiles = row.children;
    var boxes = Array.prototype.slice.call(row.querySelectorAll('[data-vr]'));
    var auto = !reduced && 'IntersectionObserver' in window;
    var sect = rail.closest('.vh-vids');
    if (auto && sect) sect.classList.add('vr-auto');

    /* arrows on computers, dots on phones (same feel as the product rows) */
    function step() { return tiles.length > 1 ? (tiles[1].offsetLeft - tiles[0].offsetLeft) || 1 : 1; }
    if (tiles.length < 2) rail.classList.add('vh-solo');
    if (dots && tiles.length > 1) {
      for (var i = 0; i < tiles.length; i++) {
        var d = document.createElement('i');
        (function (n) { d.addEventListener('click', function () { row.scrollTo({ left: tiles[n].offsetLeft - tiles[0].offsetLeft, behavior: 'smooth' }); }); })(i);
        dots.appendChild(d);
      }
    }
    function page(dir) {
      var per = Math.max(1, Math.floor((row.clientWidth - 40) / step()));
      row.scrollBy({ left: dir * per * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    var on = -1, ticking = false;
    function mark() {
      ticking = false;
      var max = row.scrollWidth - row.clientWidth;
      if (prev) prev.disabled = row.scrollLeft < 4;
      if (next) next.disabled = row.scrollLeft > max - 4;
      rail.classList.toggle('vh-fits', max < 4);
      if (dots) dots.hidden = max < 4;
      if (!dots || !dots.children.length) return;
      var n = Math.round(row.scrollLeft / step());
      if (row.scrollLeft > max - 4) n = tiles.length - 1;
      n = Math.max(0, Math.min(tiles.length - 1, n));
      if (n === on) return;
      if (on > -1) dots.children[on].className = '';
      dots.children[n].className = 'on';
      on = n;
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(mark); } }
    row.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    mark();

    /* playback */
    function vid(box) { return box.querySelector('video'); }
    function label(box, txt) { var b = box.querySelector('[data-vr-play]'); if (b) b.setAttribute('aria-label', txt); }
    function setSound(box, loud) {
      vid(box).muted = !loud;
      box.classList.toggle('is-sound', loud);
      label(box, loud ? 'Turn sound off' : (auto ? 'Turn sound on' : 'Pause video'));
    }
    function start(box) {
      var v = vid(box), p = v.play();
      if (p && p.catch) p.catch(function () { if (v.paused) { box.classList.add('is-blocked'); label(box, 'Play video'); } });
    }
    function stop(box) {
      var v = vid(box);
      if (!v.paused) v.pause();
      if (box.classList.contains('is-sound')) setSound(box, false);
    }
    function hush(keep) {
      boxes.forEach(function (o) {
        if (o === keep) return;
        if (o.classList.contains('is-sound')) setSound(o, false);
        if (!auto) stop(o);
      });
    }
    boxes.forEach(function (box) {
      var v = vid(box), btn = box.querySelector('[data-vr-play]');
      if (!v || !btn) return;
      v.removeAttribute('controls');
      v.muted = true;
      v.addEventListener('playing', function () {
        box.classList.add('is-playing'); box.classList.remove('is-blocked');
        if (!box.classList.contains('is-sound')) label(box, auto ? 'Turn sound on' : 'Pause video');
      });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); if (!auto) label(box, 'Play video'); });
      btn.addEventListener('click', function () {
        if (v.paused) { hush(box); setSound(box, true); start(box); return; }
        if (!auto) { stop(box); return; }
        if (v.muted) { hush(box); setSound(box, true); } else setSound(box, false);
      });
    });
    if (auto) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) start(e.target);
          else stop(e.target);
        });
      }, { threshold: [0, 0.6] });
      boxes.forEach(function (b) { io.observe(b); });
    }
  });

  /* ---------- back in stock ---------- */
  document.querySelectorAll('[data-bis]').forEach(function (box) {
    var key = (box.getAttribute('data-key') || '').trim();
    document.addEventListener('viora:variant', function (e) {
      box.setAttribute('data-variant', e.detail.id);
      box.hidden = !!e.detail.available;
    });
    var form = box.querySelector('form');
    if (!form || !key) return; /* no key: the normal Shopify signup form does the job */
    form.addEventListener('submit', function (e) {
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]'); if (btn) busy(btn, true);
      var body = { data: { type: 'back-in-stock-subscription', attributes: {
        profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } },
        channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + box.getAttribute('data-variant') } } } } };
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' }, body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('klaviyo');
        form.hidden = true; box.querySelector('[data-bis-ok]').hidden = false;
      }).catch(function () {
        if (btn) busy(btn, false);
        form.submit(); /* Klaviyo didn't take it: fall back to saving the email in Shopify */
      });
    });
  });
})();
